import { Injectable } from '@angular/core';

@Injectable()
export class TeamNavigationService {
    private teamPaths: string[] = [];

    constructor() {}

    getAllTeamPaths(): string[] {
        return this.teamPaths;
    }

    addTeamPath(path: string): void {
        this.teamPaths.push(path);
    }

    getPreviousTeamPath(): string {
        return this.teamPaths[this.teamPaths.length - 1];
    }

    removeLastTeamPath(): void {
        this.teamPaths.pop();
    }
}
